import { render, staticRenderFns } from "./ExternalSms.vue?vue&type=template&id=1588761a&"
import script from "./ExternalSms.vue?vue&type=script&lang=js&"
export * from "./ExternalSms.vue?vue&type=script&lang=js&"
import style0 from "./ExternalSms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports